<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row dense v-if="user.tipo == 'ADMIN'">
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          v-model="empresaSelecionada"
          :items="empresas"
          item-text="nome"
          item-value="id"
          label="Selecione a empresa"
          @input="carregaCartoes(empresaSelecionada);"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
          :loading="tabela.carregamento"
          loading-text="Buscando itens..."
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">CARTÕES</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon @click="editItem(item)" color="#01579B">mdi-details</v-icon>
                </v-btn>
              </template>
              <span>Detalhes</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <p style="margin: 0px">{{item.situacao ? 'Ativo' : 'Inativo'}}</p>
          </template>
          <template v-slot:[`item.saldo`]="{ item }">
            {{ item.saldo != '' ? "******" : item.saldo}}
          </template>
          <template v-slot:[`item.created`]="{ item }">
            {{ formatDateHora(item.created)}}
          </template>
          <template v-slot:[`item.consumidor.nome`]="{ item }">
            {{ item.consumidor && item.consumidor.nome ? item.consumidor.nome : 'Consumidor removido' }}
          </template>
          <template v-slot:no-data>
            <v-row>
              <v-col>
                <v-alert dark dense text outlined color="warning" icon="info" style="margin: 0px">Nenhum cartão cadastrado</v-alert>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
      <v-col>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn fab v-on="on" @click="gerarPDF" color="primary" :disabled="tabela.conteudo.length == 0" depressed>
              <v-icon large>cloud_download</v-icon>
            </v-btn>
          </template>
          <span>Baixar Relatório</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogCartoes" persistent max-width="500px" >
      <v-card>
        <v-card-title>{{ formTitle }}</v-card-title>
        <v-card-text style="padding-bottom: 0px">
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field readonly label="Nome" outlined dense hide-details :value="editedItem.consumidor && editedItem.consumidor.nome ? editedItem.consumidor.nome : 'Consumidor removido'"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field readonly label="Matricula" outlined dense hide-details :value="editedItem.consumidor && editedItem.consumidor.matricula ? editedItem.consumidor.matricula : '---'"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field readonly label="Turma" outlined dense hide-details :value="editedItem.consumidor && editedItem.consumidor.turma ? editedItem.consumidor.turma : '---'"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field readonly label="Saldo" outlined dense hide-details v-model="editedItem.saldo"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field
                label="QR Code"
                outlined
                dense
                hide-details
                :value="editedItem.qrCode"
                @input="editedItem.qrCode = $event ? $event.toUpperCase() : ''"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field readonly label="QrCode" outlined dense hide-details v-model="editedItem.created"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12">
              <v-text-field readonly label="Situacao" outlined dense hide-details v-model="editedItem.situacao"></v-text-field>
            </v-col>
            <v-col v-if="user.tipo == 'ADMIN' && editedItem.qrCode" cols="12" xs="12" sm="12" md="12" lg="12" >
             <v-btn @click="zerarCartaoConsumo(editedItem.qrCode)" color="primary" outlined dense>Formatar Cartão</v-btn>
          </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="dialogCartoes = false">Fechar</v-btn>
          <v-btn text color="success" @click="salvarQrCode">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import pdfMake from 'pdfmake/build/pdfmake';
  import pdfFonts from 'pdfmake/build/vfs_fonts';
  if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  }

  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      lojistas: [],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'consumidor.nome', },
          { text: 'Matricula', value: 'consumidor.matricula', },
          { text: 'Turma', value: 'consumidor.turma' },
          { text: 'Saldo', value: 'saldo' },
          { text: 'QRCODE', value: 'qrCode' },
          { text: 'Situação', value: 'situacao' },
          { text: 'Data/Hora Emissão', value: 'created' },
          { text: 'Ações', value: 'action', sortable: false, align: 'center' },
        ],
        carregamento: false,
        conteudo: [],
      },
      dialogCartoes: false,
      editedIndex: -1,
      editedItem: {
        consumidor: {
        nome: '',
        matricula: '',
        turma: '',
        },
        saldo: '',
        qrcode: '',
        situacao: '',
        emissao: ''
      },
      defaultItem: {
        consumidor: {
        nome: '',
        matricula: '',
        turma: '',
        },
        saldo: '',
        qrcode: '',
        situacao: '',
        emissao: ''
      },
      empresas: [],
      empresaSelecionada: '',
      lojistaSelecionado: '',
    }),

    computed: mapState({
      ConsumidorLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo usuário' : 'Detalhes do Cartão'
      },

      nomeEmpresa() {
        if (this.user.tipo !== 'ADMIN') return this.companyObj.nome

        let empresa = this.empresas.find(e => e.id === this.empresaSelecionada)
        return empresa ? empresa.nome : ''
      },
    }),

    watch: {
      dialogCartoes(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      },
    },

    mounted() {
      if (this.user.tipo == 'ADMIN') {
        this.carregaEmpresas()
      } else {
        this.carregaCartoes()
      }
    },

    methods: {

     async zerarCartaoConsumo(qrcode) {
      var vm = this;
      await axios.post(baseApiUrl + 'CartoesConsumo/zerarCartao', {"qrCode":qrcode}).then(response => {
        if (response.data) {
          vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!")
        }
      })
      .catch(() => {
         vm.$refs.chamaSnackbar.snack("red", "Erro ao realizar operação", "DESCULPE")
      })
     },
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.empresas = response.data
          }
        })
      },

      formatDateHora(date) {
      if (!date) return null

      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },

      async carregaCartoes (empresaId) {
        let url = ''
        this.tabela.conteudo = []
        this.isLoading = true
        this.tabela.carregamento = true


        if (empresaId) {
          url = baseApiUrl + 'CartoesConsumo?filter={"where":{"empresaId":"' + empresaId + '"},"include":["consumidor"]}&access_token=' + sessionStorage.getItem('accToken')
        } else {
          url = baseApiUrl + 'CartoesConsumo?filter={"where":{"empresaId":"' + this.user.empresaId + '"},"include":["consumidor"]}&access_token=' + sessionStorage.getItem('accToken')
        }

        await axios.get(url)
        .then(response => {
          if (response.data) {
            this.tabela.conteudo = response.data
            this.tabela.carregamento = false
          }
          this.isLoading = false
        })
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editedItem.created = this.formatDateHora(this.editedItem.created)
        if(this.editedItem.situacao)
          this.editedItem.situacao = 'Ativo'
        else
          this.editedItem.situacao = 'Inativo'
        this.dialogCartoes = true
        this.isLoading = false
      },

      async salvarQrCode() {
        var vm = this;
        if (!this.editedItem.id || !this.editedItem.qrCode) {
          vm.$refs.chamaSnackbar.snack("orange", "QR Code ou ID do cartão não informado!", "ATENÇÃO");
          return;
        }
        this.isLoading = true;
        await axios.patch(baseApiUrl + 'CartoesConsumo/' + this.editedItem.id + '?access_token=' + sessionStorage.getItem('accToken'), {
          qrCode: this.editedItem.qrCode
        })
        .then(() => {
          this.isLoading = false;
          this.dialogCartoes = false;
          vm.$refs.chamaSnackbar.snack("green", "QR Code atualizado com sucesso!", "INFORMAÇÃO");
          this.carregaCartoes(this.user.tipo == 'ADMIN' ? this.empresaSelecionada : this.user.empresaId);
        })
        .catch(() => {
          this.isLoading = false;
          vm.$refs.chamaSnackbar.snack("red", "Erro ao atualizar QR Code", "DESCULPE");
        });
      },

      gerarPDF() {
        const docDefinition = {
          content: [
            { text: `Relatório de Cartões - ${this.nomeEmpresa} - ${new Date().toLocaleString('pt-BR')}`, style: 'header' },
            {
              style: 'cardsTable',
              table: {
                headerRows: 1,
                widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto' ],
                dontBreakRows: true,
                body: [
                  // Cabeçalhos da tabela
                  [
                    { text: `Nome`, style: 'tableHeader' },
                    { text: `Matrícula`, style: 'tableHeader' },
                    { text: `Telefone`, style: 'tableHeader' },
                    { text: `Turma`, style: 'tableHeader' },
                    { text: `Saldo`, style: 'tableHeader' },
                    { text: `Situacao`, style: 'tableHeader' },
                    { text: `Emitido em`, style: 'tableHeader' }
                  ],

                  // Dados dos cartões
                  ...[...this.tabela.conteudo]
                    .sort((a, b) => {
                      const nomeA = a.consumidor && a.consumidor.nome ? a.consumidor.nome : 'Consumidor removido'
                      const nomeB = b.consumidor && b.consumidor.nome ? b.consumidor.nome : 'Consumidor removido'
                      return nomeA.localeCompare(nomeB)
                    })
                    .map(c => [
                      c.consumidor ? c.consumidor.nome : 'Consumidor removido',
                      c.consumidor ? c.consumidor.matricula : 'Consumidor removido',
                      c.consumidor ? c.consumidor.whatsApp : 'Consumidor removido',
                      c.consumidor ? c.consumidor.turma : 'Consumidor removido',
                      c.saldo,
                      c.situacao ? "Ativo" : "Inativo",
                      this.formatDateHora(c.created),
                    ])
                ]
              },
              layout: 'lightHorizontalLines',
            }
          ],
          styles: {
            header: {
              fontSize: 16,
              bold: true,
              margin: [0, 0, 0, 10]
            },
            tableHeader: {
              bold: true,
              fontSize: 10,
              color: 'black',
              margin: [0, 5, 0, 5]
            },
            cardsTable: {
              margin: [0, 20, 0, 0]
            }
          },

          defaultStyle: {
            columnGap: 10
          }
        };

        pdfMake.createPdf(docDefinition).download(`Cartões ${this.nomeEmpresa}.pdf`);
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }

  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>
